import React from 'react';
import PropTypes from 'prop-types';
import { Timeline } from 'antd';
import { FORMAT_DEFAULT } from '../../utils/dates';
import dayjs from '../../utils/dayjs';
import './NotificationList.css';

const notificationDateSorter = (a, b) =>
  dayjs(a.createdDate, FORMAT_DEFAULT, true).isBefore(
    dayjs(b.createdDate, FORMAT_DEFAULT, true)
  )
    ? 1
    : -1;

class NotificationList extends React.Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  handleClickView = (e, id) => {
    const { showModal } = this.props;
    e.preventDefault();
    showModal(id);
  };

  render() {
    const { list, t } = this.props;

    return (
      <Timeline className="component-NotificationList">
        {list.sort(notificationDateSorter).map((item) => (
          <Timeline.Item key={item.id}>
            <span>[{item.createdDate}]</span>
            <b> {item.title}</b>
            <a
              href="/notification"
              className="component-NotificationList__view-button"
              onClick={(e) => this.handleClickView(e, item.id)}
            >
              {t('viewButton')}
            </a>
          </Timeline.Item>
        ))}
      </Timeline>
    );
  }
}

export default NotificationList;
